{
  "exportGeoJson": {
    "exportLayersInfo": "As camadas selecionadas estão sendo exportadas, avisaremos quando estiverem prontas"
  },
  "importGeoJson": {
    "invalidGeoJson": {
      "title": "Tipo de arquivo inválido",
      "message": "O arquivo que você enviou é inválido. Faça upload de um arquivo GeoJSON, JSON, GPX ou KML/KMZ válido."
    },
    "somethingWentWrong": {
      "title": "Algo deu errado",
      "message": "O tipo de arquivo que você enviou é inválido. Faça upload de um arquivo GeoJSON, JSON, GPX ou KML/KMZ válido."
    },
    "fileTooLarge": {
      "title": "Tamanho do arquivo muito grande",
      "message": "O arquivo que você está tentando enviar é muito grande. O tamanho máximo do arquivo é {{ size }}"
    },
    "invalidGeometry": {
      "title": "Geometria inválida",
      "message": "O tipo de camada que você está tentando carregar tem geometria inválida."
    },
    "invalidLayerType": {
      "title": "Tipo de camada incompatível",
      "message": "Você está tentando fazer upload de uma camada {{ importType }} para uma camada {{ layerType }}"
    },
    "invalidCoordinateSystem": {
      "title": "Sistema de coordenadas não suportado",
      "message": "O sistema de coordenadas não é suportado, use {{ coordinateSystem }}"
    },
    "reuploadGeoJson": "A extensão de arquivo suportada é {{ fileExtensions }} e o tamanho máximo do arquivo é de até {{ size }}",
    "mappedAttributeDescription": "Selecione propriedades do arquivo para importar como atributos de camada (opcional).",
    "layerAttribute": "Atributo de camada",
    "type": "Tipo",
    "fieldToImport": "Campo a ser importado",
    "overwriteExisting": "Substituir o existente",
    "importLayer": "Camada de importação"
  },
  "importKML": {
    "invalidKML": {
      "title": "Dados KML inválidos",
      "message": "Os dados KML são inválidos. Verifique seu arquivo de origem e tente novamente."
    },
    "folderSelectLabel": "Camadas de importação padrão",
    "allFolders": "Todas as camadas"
  },
  "importGpx": {
    "invalidGpx": {
      "title": "Dados GPX inválidos",
      "message": "Os dados GPX são inválidos. Verifique seu arquivo de origem e tente novamente."
    },
    "import_track": "Importar faixa",
    "import_route": "Rota de importação"
  },
  "analysis_drawing_tooltips": {
    "title": "Ferramentas de análise",
    "enter_edit_mode": "Use as ferramentas de desenho para selecionar objetos do mapa e analisar áreas, linhas etc.",
    "enter_edit_mode_link": "Clique aqui para saber mais sobre essa ferramenta"
  },
  "dataTableGrouping": {
    "checkbox": "Dados do grupo"
  },
  "assets": {
    "edit": "Editar ativo selecionado",
    "delete": "Excluir ativo selecionado",
    "uploadAsset": "Carregar ativo",
    "deleteTitleIcon": "Excluir ícone",
    "deleteDescriptionIcon": "Tem certeza de que deseja excluir esse ícone?",
    "deleteTitleModel": "Excluir modelo",
    "deleteDescriptionModel": "Tem certeza de que deseja excluir esse modo?"
  },
  "toolbarButtonTooltips": {
    "route": "Gerador de rotas"
  },
  "routeGenerator": {
    "routeGenerator": "Gerador de rotas",
    "distance": "Distância",
    "travelTime": "Tempo de viagem",
    "addStop": "Adicionar parada",
    "addRoute": "Nova rota",
    "removeStop": "Remover parada",
    "search": "Pesquise ou clique no mapa"
  },
  "exports": {
    "remarks": {
      "title": "Observações personalizadas",
      "placeholder": "Insira comentários personalizados aqui",
      "error": "As observações são muito longas"
    }
  },
  "styles": {
    "modelOffset": "Offset do modelo"
  },
  "attributes": {
    "imageDescription": "Você só pode fazer upload de 1 imagem por atributo. Você pode substituir sua seleção abaixo.",
    "imageTitle": "Carregar imagem para atribuir",
    "noImageSelected": "Nenhum arquivo escolhido"
  },
  "layerTemplates": {
    "chosenForYou": "Escolhido para você"
  },
  "contextMenu": {
    "addAttributeMultipleLayers": "Adicionar atributo a todos"
  },
  "importLayers": {
    "folderOutsideMap": "Não é possível importar uma pasta de fora de um mapa"
  },
  "delete": {
    "multipleTitleMix": "Excluir vários itens",
    "multipleDescriptionMix": "A exclusão de um grupo excluirá todas as camadas e seus objetos",
    "importLayerHint": "A camada importada só será removida do mapa e existirá no plano original",
    "multipleLayersTitle": "Excluir várias camadas",
    "multipleLayersDescription": "A exclusão de várias camadas também excluirá todos os objetos nelas.",
    "multipleImportLayersTitle": "Remover camadas importadas",
    "singleImportLayersTitle": "Remover camada importada",
    "importLayersDescription": "A exclusão da camada importada excluirá somente os objetos do seu mapa. Você pode importar a camada do mapa vinculado a qualquer momento",
    "singleLayerTitle": "Excluir uma camada",
    "singleLayerDescription": "A exclusão dessa camada também excluirá todos os objetos nela."
  }
}